import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UnApprovedCustomersModel } from "@tSurya/Services/SurUnApprovedCustomersListService";
import { UnApprovedCustomersState } from "@tSurya/Store/Data/SurUnApprovedCustomersState";
import { Draft } from "immer";

const initialState: UnApprovedCustomersState = {
    isLoading: false,
    unApprovedCustomersStore: undefined,
};

const reducer = {
    "Custom/UnApprovedCustomers/BeginLoadUnApprovedCustomers": (draft: Draft<UnApprovedCustomersState>) => {
        draft.isLoading = true;
    },
    "Custom/UnApprovedCustomers/CompletedLoadUnApprovedCustomers": (
        draft: Draft<UnApprovedCustomersState>,
        action: { result: UnApprovedCustomersModel },
    ) => {
        draft.unApprovedCustomersStore = action.result;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
